// import React, { createContext, useState, useContext, useEffect, useCallback } from 'react'
// import PropTypes from 'prop-types'
// import { decodeToken } from 'src/decodeToken'
// const AuthContext = createContext(null)

// export const AuthProvider = ({ children }) => {
//   const [admin, setAdmin] = useState(false)
//   const [HelpDesk, setHelpDesk] = useState(false)
//   const [Facilitator, setFacilitator] = useState(false)
//   const [FacilitatorAdmin, setFacilitatorAdmin] = useState(false)
//   const [LaungFacilitator, setLaungFacilitator] = useState(false)
//   const [RaxaFacilitator, setRaxaFacilitator] = useState(false)
//   const [BuggyFacilitator, setBuggyFacilitator] = useState(false)

//   const getTheUser = useCallback(() => {
//     const token = sessionStorage.getItem('token')
//     if (token) {
//       const decodedToken = decodeToken(token)
//       const roles = decodedToken.role
//       const role = roles[0]
//       if (role === 'Admin') {
//         setAdmin(true)
//       }
//       if (role === 'Help Desk') {
//         setHelpDesk(true)
//       }

//       if (role === 'Facilitator') {
//         setFacilitator(true)
//       }
//       if (role === 'Facilitator Admin') {
//         setFacilitatorAdmin(true)
//       }

//       if (role === 'Buggy Facilitator') {
//         setBuggyFacilitator(true)
//       }

//       if (role === 'Raxa Facilitator') {
//         setRaxaFacilitator(true)
//       }
//       if (role === 'Lounge Facilitator') {
//         setLaungFacilitator(true)
//       }
//     } else {
//       setAdmin(false)
//       setHelpDesk(false)
//       setFacilitator(false)
//       setFacilitatorAdmin(false)
//       setBuggyFacilitator(false)
//       setRaxaFacilitator(false)
//       setLaungFacilitator(false)
//     }
//   }, [])

//   useEffect(() => {
//     getTheUser()
//   }, [getTheUser])

//   const switchUser = useCallback(() => {
//     const token = sessionStorage.getItem('token')
//     if (token) {
//       const decodedToken = decodeToken(token)
//       const roles = decodedToken.role
//       const role = roles[0]
//       if (role === 'Admin') {
//         setAdmin(true)
//       }
//       if (role === 'Help Desk') {
//         setHelpDesk(true)
//       }

//       if (role === 'Facilitator') {
//         setFacilitator(true)
//       }
//       if (role === 'Facilitator Admin') {
//         setFacilitatorAdmin(true)
//       }
//       if (role === 'Buggy Facilitator') {
//         setBuggyFacilitator(true)
//       }
//       if (role === 'Raxa Facilitator') {
//         setRaxaFacilitator(true)
//       }
//       if (role === 'Lounge Facilitator') {
//         setLaungFacilitator(true)
//       }
//     } else {
//       // Handle case where token doesn't exist (user logged out)
//       setAdmin(false)
//       setHelpDesk(false)
//       setFacilitator(false)
//       setFacilitatorAdmin(false)
//       setBuggyFacilitator(false)
//       setRaxaFacilitator(false)
//       setLaungFacilitator(false)
//     }
//   }, [])

//   useEffect(() => {
//     switchUser()
//   }, [getTheUser])
  

//   return (
//     <AuthContext.Provider
//       value={{
//         admin,
//         setAdmin,
//         HelpDesk,
//         getTheUser,
//         setHelpDesk,
//         Facilitator,
//         setFacilitator,
//         FacilitatorAdmin,
//         setFacilitatorAdmin,
//         BuggyFacilitator,
//         setBuggyFacilitator,
//         RaxaFacilitator,
//         setRaxaFacilitator,
//         LaungFacilitator,
//         setLaungFacilitator,
//       }}
//     >
//       {children}
//     </AuthContext.Provider>
//   )
// }

// AuthProvider.propTypes = {
//   children: PropTypes.node.isRequired,
// }

// export const useAuth = () => useContext(AuthContext)

import React, { createContext, useState, useContext, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import { decodeToken } from 'src/decodeToken'

const AuthContext = createContext(null)

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(false)
  const [HelpDesk, setHelpDesk] = useState(false)
  const [Facilitator, setFacilitator] = useState(false)
  const [FacilitatorAdmin, setFacilitatorAdmin] = useState(false)
  const [LaungFacilitator, setLaungFacilitator] = useState(false)
  const [RaxaFacilitator, setRaxaFacilitator] = useState(false)
  const [BuggyFacilitator, setBuggyFacilitator] = useState(false)

  const resetRoles = () => {
    setAdmin(false)
    setHelpDesk(false)
    setFacilitator(false)
    setFacilitatorAdmin(false)
    setBuggyFacilitator(false)
    setRaxaFacilitator(false)
    setLaungFacilitator(false)
  }

 const evaluateRoles = useCallback(() => {
  const token = sessionStorage.getItem('token')
  if (token) {
    const decodedToken = decodeToken(token)
    const roles = decodedToken.role

    const storedRole = localStorage.getItem('role')
    const role = storedRole ? storedRole.trim().replace(/\s+/g, ' ') : ''

    resetRoles()

    switch (role) {
      case 'Admin':
        setAdmin(true)
        break
      case 'Help Desk':
        setHelpDesk(true)
        break
      case 'Facilitator':
        setFacilitator(true)
        break
      case 'Facilitator Admin':
        setFacilitatorAdmin(true)
        break
      case 'Buggy Facilitator':
        setBuggyFacilitator(true)
        break
      case 'Raxa Facilitator':
        setRaxaFacilitator(true)
        break
      case 'Lounge Facilitator':
        setLaungFacilitator(true)
        break
      default:
        // Unknown or missing role
        break
    }
  }
}, [])


  useEffect(() => {
    evaluateRoles()
  }, [evaluateRoles])

  return (
    <AuthContext.Provider
      value={{
        admin,
        setAdmin,
        HelpDesk,
        setHelpDesk,
        Facilitator,
        setFacilitator,
        FacilitatorAdmin,
        setFacilitatorAdmin,
        BuggyFacilitator,
        setBuggyFacilitator,
        RaxaFacilitator,
        setRaxaFacilitator,
        LaungFacilitator,
        setLaungFacilitator,
        getTheUser: evaluateRoles, // expose manual refresh
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export const useAuth = () => useContext(AuthContext)
